export default {
    'export': 'Export',
    'export-as-excel': 'Export to excel',
    'print-warehouse-inventory': 'Print warehouse inventory',
    'search-by-material-name-or-num': 'Find item ID or name',
    warehouse: 'Warehouse',
    'show-main-materials': 'Show main items',
    'only-materials-which-have-balances': 'Only items with balances',
    refresh: 'Refresh',
    cancel: 'Cancel',
    'total-count': 'Total count',
    'total-quantity': 'Total quantity',
    'warehouse-inventory': 'Warehouse inventory',
    'inventory-price': 'Inventory price',
    save: 'Save',

    warning: 'Alert',
    'it-is-not-possible-to-set-main-material-inventory-price': "Can't set an inventory price for a main item!",

    headers: {
        'material-no': 'Item ID',
        'material-name': 'Item name',
        count: 'Count ',
        'unit-size': 'Unit',
        quantity: 'Quantity',
        price: 'Price',
        'total-amount': 'Amount',
    },

    'context-menu': {
        'edit-inventory-price': 'Edit inventory price',
        'material-statement': 'Item statement',
    },
    
    'edit-inventory-price': 'Edit inventory price of ',
    'delivered': 'Delivered',
    'being-received': 'Under received',
    'being-deliver': 'Under delivery',
    'material-delivery-status': 'Material delivery status'
}